import ExodusModule from '@exodus/module';
import { sanitizeErrorMessage } from '@exodus/errors';
const MODULE_ID = 'exchangeTracer';
export class ExchangeTracerModule extends ExodusModule {
    #messages = [];
    #timesById = new Map();
    #logger;
    timeLogs = new Map();
    constructor({ logger }) {
        super({ MODULE_ID, logger });
        this.#logger = logger;
    }
    traceMessage(message) {
        this.#messages.push(sanitizeErrorMessage(message));
    }
    traceError(error) {
        const message = error.isExchange
            ? JSON.stringify(error)
            : sanitizeErrorMessage(process.env.NODE_ENV === 'test'
                ? error.message
                : (error.stack || error.cause?.toString() || '').slice(0, 3000));
        this.#messages.push(message);
        this.#logger.error(message);
    }
    traceTime(id) {
        if (this.#timesById.has(id)) {
            this.#logger.warn(`Time tracer with id ${id} already started`);
            return;
        }
        const start = Date.now();
        this.#timesById.set(id, start);
    }
    traceTimeEnd(id) {
        const start = this.#timesById.get(id);
        if (!start) {
            this.#logger.warn(`Time tracer with id ${id} not started`);
            return;
        }
        const end = Date.now();
        const duration = end - start;
        this.timeLogs.set(id, duration);
        this.#timesById.delete(id);
    }
    clear() {
        this.#messages = [];
        this.timeLogs.clear();
        this.#timesById.clear();
    }
    print() {
        return this.#messages.join('\n');
    }
}
const exchangeTracerModuleFactory = (args) => new ExchangeTracerModule({ ...args });
const exchangeTracerModuleDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: exchangeTracerModuleFactory,
    dependencies: ['logger'],
};
export default exchangeTracerModuleDefinition;
